export default class extends HTMLElement {
  connectedCallback() {
    // Get submission ID from data attribute
    this.submissionId = this.getAttribute('data-submission-id')
    
    // Set up event listener for the toggle button
    this.toggleButton = this.querySelector('.toggle-button')
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.toggleBccRecipients.bind(this))
    }
    
    // Prevent clicks on the whole component from bubbling up
    this.addEventListener('click', this.preventPropagation.bind(this))
  }
  
  disconnectedCallback() {
    // Clean up event listeners
    if (this.toggleButton) {
      this.toggleButton.removeEventListener('click', this.toggleBccRecipients.bind(this))
    }
    this.removeEventListener('click', this.preventPropagation.bind(this))
  }
  
  preventPropagation(event) {
    // Stop the click from bubbling up to parent elements
    event.stopPropagation()
  }
  
  toggleBccRecipients(event) {
    // Prevent default behavior and stop propagation
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    const hiddenDiv = this.querySelector('.hidden-recipients')
    const showMoreText = this.querySelector('.show-more-text')
    const showLessText = this.querySelector('.show-less-text')
    
    if (hiddenDiv.classList.contains('hidden')) {
      hiddenDiv.classList.remove('hidden')
      showMoreText.classList.add('hidden')
      showLessText.classList.remove('hidden')
    } else {
      hiddenDiv.classList.add('hidden')
      showMoreText.classList.remove('hidden')
      showLessText.classList.add('hidden')
    }
  }
}
